import React from "react";
import Modal from "../../Modal";
import {
  Body,
  Checkers,
  Container,
  DivIcon,
  Footer,
  Header,
  Title,
  Warning,
  WarningText,
} from "./styles";
import Lock from "../../../../assets/icons/Lock";
import Exclamation from "../../../../assets/icons/Exclamation";
import Input from "../../Input";
import { useState } from "react";
import { useDispatch } from "react-redux";
import Button from "../../Button";
import Close from "../../../../assets/icons/Close";
import { handleUpdatePassword } from "../../../../state/users/actions";
import { toastAlert } from "../../../Toastify/index";
import { signOut } from "../../../../state/auth/actions";

const ChangePasswordModal = ({ isOpen, onClose, selector, className }) => {
  const [old_password, setOld] = useState("");
  const [new_password, setNew] = useState({ password: "", repeat: "" });

  const dispatch = useDispatch();
  const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d]{8,}$/;

  return (
    <Modal
      id="pass_modal"
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Header>
          <Lock style={{ width: "1.6rem", height: "1.6rem" }} />
          <Title>Alterar Senha</Title>
        </Header>
        <Warning>
          <Exclamation />
          <WarningText>
            Aviso: Caso de esquecimento da senha atual, vá para área de login e
            solicite a redefinição de senha.
          </WarningText>
        </Warning>
        <Body>
          <Input
            value={old_password}
            setValue={(e) => {
              setOld(e);
            }}
            label="Senha atual"
            placeholder={"Digite sua senha..."}
            error={false}
            errorMsg={"Senha incorreta"}
            type="password"
          />
          <Input
            value={new_password.password}
            setValue={(e) => {
              setNew({ ...new_password, password: e });
            }}
            label="Nova senha"
            placeholder={"Digite sua nova senha..."}
            type="password"
          />
          <Input
            value={new_password.repeat}
            setValue={(e) => {
              setNew({ ...new_password, repeat: e });
            }}
            label="Repetir nova senha"
            placeholder={"Repita sua nova senha..."}
            type="password"
          />
          <Checkers check={regex.test(new_password.password)}>
            Senha deve ter no mínimo 8 caracteres, conter pelo menos uma letra
            maiúscula, uma letra minúscula e um número
          </Checkers>
          <Checkers check={new_password.password === new_password.repeat}>
            as novas senhas devem ser iguais
          </Checkers>
        </Body>
        <Footer>
          <Button
            outline
            content={"Cancelar"}
            width={"12.17rem"}
            onClick={onClose}
          />
          <Button
            onClick={() => {
              dispatch(
                handleUpdatePassword({
                  old_password: old_password,
                  new_password: new_password.password,
                })
              )
                .then((res) => {
                  toastAlert({
                    msg: "Dados de usuário atualizados com sucesso! Entre com sua conta para VALIDAR as infomações.",
                  });
                  dispatch(signOut());
                })
                .catch((err) =>
                  toastAlert({
                    msg: `Ocorreu um ERRO ao atualizar os dados de usuário: ${err}`,
                    isError: true,
                  })
                );
            }}
            disabled={
              new_password.password !== new_password.repeat ||
              new_password.password === "" ||
              !regex.test(new_password.password)
            }
            content={"Alterar"}
            width={"12.17rem"}
          />
        </Footer>
        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default ChangePasswordModal;
